<div class="mat-typography pdf-document-viewer-dialog">
    <h2 mat-dialog-title>
        <div fxFlex>
            <p class="primary-color">
                <b>{{ data.dialogTitle }}</b>
            </p>
            <p class="accent-color" style="font-size: 16px;"
                *ngIf="!showSpinner && data.dialogSubTitle !== null && data.dialogSubTitle.length > 0">
                <b>{{ data.dialogSubTitle }}</b>
            </p>
        </div>
    </h2>
    <div *ngIf="showSpinner">
        <p style="text-align: center"><mat-spinner color="accent" diameter="36"></mat-spinner></p>
    </div>
    <div class="border-bottom-blue" style="margin-top: 16px; margin-bottom: 0px;" *ngIf="!showSpinner"></div>
    <div id="dialog-pdf-viewer" mat-dialog-content [ngStyle.lt-md]="{ 'max-height': pdfHeight }"
        style="margin-top: 16px; margin-bottom: 16px; margin-left: 2px; margin-right: 2px;">
        <pdf-viewer id="pdf-viewer" class="pdf-viewer" [src]="pdfDocumentInitParameters" [original-size]="originalSize"
            [fit-to-page]="fitToPage" [autoresize]="autoResize" [zoom]="zoom"
            (after-load-complete)="pdfLoadComplete($event)" (error)="pdfLoadError($event)"></pdf-viewer>
        <div class="warning-color" *ngIf="!showSpinner && !pdfLoadOK">
            <b>
                <span i18n="@@pdf-document-viewer-dialog.error.1a">pdf-document-viewer-dialog.error.1a</span>&nbsp;{{
                data.errorTitle }}&nbsp;<span
                    i18n="@@pdf-document-viewer-dialog.error.1b">pdf-document-viewer-dialog.error.1b</span><br />
                <span i18n="@@pdf-document-viewer-dialog.error.2">pdf-document-viewer-dialog.error.2</span>
            </b>
        </div>
    </div>
    <div mat-dialog-actions style="display: flex; flex-direction: column; gap: 16px;">
        <div class="actions-sizer">
            <span class="acceptance-text" *ngIf="data.requireScrollToEnd && !showSpinner && pdfLoadOK" fxLayout="row wrap"
                fxLayoutAlign="start center" fxLayoutGap="8px">
                <mat-checkbox [(ngModel)]="pdfViewConfirmed" [disabled]="!pdfScrolledToBottom" fxFlex="100"
                    class="acceptance-checkbox">
                    <b>
                        <span [ngClass]="{ 'primary-color': pdfScrolledToBottom }"
                            i18n="@@pdf-document-viewer-dialog.acceptance.1a">
                            pdf-document-viewer-dialog.acceptance.1a
                        </span>
                        <span [ngClass]="{ 'primary-color': pdfScrolledToBottom }">
                            &nbsp;{{ data.acceptanceTitle }}&nbsp;
                        </span>
                        <span [ngClass]="{ 'primary-color': pdfScrolledToBottom }"
                            i18n="@@pdf-document-viewer-dialog.acceptance.1b">
                            pdf-document-viewer-dialog.acceptance.1b
                        </span>
                    </b>
                </mat-checkbox>
            </span>
        </div>
        <div class="actions-sizer">
            <a mat-stroked-button color="primary" [href]="data.pdfUrl" target="_blank"
                *ngIf="!showSpinner && pdfLoadOK"
                i18n="@@pdf-document-viewer-dialog.download-button.label">
                pdf-document-viewer-dialog.download-button.label
            </a>

            <button mat-stroked-button color="warn" (click)="onCancelClick()"
                    *ngIf="!getShowCloseButton()"
                    class="pdf-button"
                    i18n="@@pdf-document-viewer-dialog.cancel-button.label">
                    pdf-document-viewer-dialog.cancel-button.label
            </button>

            <button mat-flat-button color="primary" (click)="onCloseClick()"
                    *ngIf="getShowCloseButton() && data.requireScrollToEnd"
                    class="pdf-button"
                    i18n="@@pdf-document-viewer-dialog.accept-close-button.label">
                    pdf-document-viewer-dialog.accept-close-button.label
            </button>

            <button mat-flat-button color="primary" (click)="onCloseClick()"
                    *ngIf="getShowCloseButton() && !data.requireScrollToEnd"
                    class="pdf-button"
                    i18n="@@pdf-document-viewer-dialog.close-button.label">
                    pdf-document-viewer-dialog.close-button.label
            </button>
        </div>
    </div>
</div>